import cx from 'classnames';
import { FiArrowUp, FiArrowDown } from 'react-icons/fi';
import styles from './VoteShare.module.css';

const UpvoteCounter = ({ count }: { count: number }) => {
  return (
    <span className={cx(styles.voteCounter, styles.upvoteCounter)}>
      <span className={styles.voteCounterIcon}>
        <FiArrowUp className={styles.voteCounterIcon} />
      </span>
      {count}
    </span>
  );
};

const DownvoteCounter = ({ count }: { count: number }) => {
  return (
    <span className={cx(styles.voteCounter, styles.downvoteCounter)}>
      <span className={styles.voteCounterIcon}>
        <FiArrowDown className={styles.voteCounterIcon} />
      </span>
      {count}
    </span>
  );
};

export const DualVoteShare = ({
  upvotes,
  downvotes,
  totalVotes,
}: {
  upvotes: number;
  downvotes: number;
  totalVotes: number;
}) => {
  const percentage = (100 * (upvotes + downvotes) / totalVotes).toFixed(2);
  const upvotePercentage = (100 * upvotes / totalVotes).toFixed(2);
  const downvotePercentage = (100 * downvotes / totalVotes).toFixed(2);

  return (
    <div className={styles.voteShare}>
      <div className={styles.voteShareStats}>
        <div className={styles.voteShareCounters}>
          <UpvoteCounter count={upvotes} />
          <DownvoteCounter count={downvotes} />
        </div>
        <div className={styles.voteShareTotal}>
          {totalVotes} ({percentage}%)
        </div>
      </div>
      <div className={styles.voteShareBar}>
        <div
          className={cx(styles.voteShareBarFill, styles.upvotes)}
          style={{
            width: `${upvotePercentage}%`
          }}
        />
        <div
          className={cx(styles.voteShareBarFill, styles.downvotes)}
          style={{
            width: `${downvotePercentage}%`
          }}
        />
      </div>
    </div>
  );
};

export const VoteShare = ({
  votes,
  totalVotes,
  type = 'upvote',
}: {
  votes: number;
  totalVotes: number;
  type?: 'upvote' | 'downvote';
}) => {
  const percentage = (100 * votes / totalVotes).toFixed(2);
  const Counter = type === 'upvote' ? UpvoteCounter : DownvoteCounter;

  return (
    <div className={styles.voteShare}>
      <div className={styles.voteShareStats}>
        <div className={styles.voteShareCounters}>
          <Counter count={votes} />
        </div>
        <div className={styles.voteShareTotal}>
          {totalVotes} ({percentage}%)
        </div>
      </div>
      <div className={styles.voteShareBar}>
        <div
          className={cx(styles.voteShareBarFill, type === 'upvote' ? styles.upvotes : styles.downvotes)}
          style={{
            width: `${percentage}%`
          }}
        />
      </div>
    </div>
  );
};
